import { API } from '../constants/api'
import { store } from '../store'
import { userSlice } from '../store/slices/user'
import { removeFromLocalStorage } from '../utils/localStorage'

export const useLogout = () => {
  store.dispatch(userSlice.actions.reset())
  removeFromLocalStorage(API.BEARER_TOKEN)
}
